import { getAppContext } from '@b2ag/micro-front-tools'

const { appFrontType } = getAppContext()

const storeAgri = () => import('./stores/agri/store')
const storeTech = () => import('./stores/tech/store')

let store: any

export async function initStore() {
  store = appFrontType === 'agri' ? (await storeAgri()).default : (await storeTech()).default

  return store
}

export function getStore() {
  return store
}
